<template>
  <BModal :model-value="modalFilter" title="Reservation Filter" centered @update:modelValue="emitUpdateModal">
    <template #header>
      <div class="d-flex align-items-center justify-content-between modal-title w-100">
        <h5>Filter</h5>
        <BButton variant="link" class="close" @click="emitUpdateModal(false)">
          <i class="ion ion-android-close"></i>
        </BButton>
      </div>
    </template>

    <BForm>
      <div class="form-group">
        <label>Payment Status</label>
        <BFormSelect v-model="selectedStatus" :options="statusOptions">
          <template #first>
            <BFormSelectOption :value="null" disabled>Select Payment status</BFormSelectOption>
          </template>
        </BFormSelect>
      </div>
    </BForm>

    <template #footer>
      <div class="d-flex justify-content-end">
        <BButton variant="light" class="mr-2" @click="resetFilter">Reset</BButton>
        <BButton variant="primary" @click="applyFilter">Filter</BButton>
      </div>
    </template>
  </BModal>
</template>

<script>
import { ref, computed } from 'vue';
import {
  BModal,
  BForm,
  BFormSelect,
  BFormSelectOption,
  BButton
} from "bootstrap-vue-next";

export default {
  name: 'ReservationFilter',
  components: {
    BModal,
    BForm,
    BFormSelect,
    BFormSelectOption,
    BButton
  },
  props: {
    modalFilter: Boolean,
  },
  emits: ['update:modalFilter', 'filter'],
  setup(props, { emit }) {
    const selectedStatus = ref(null);

    // Static options wrapped in computed for consistency/future-proofing
    const statusOptions = computed(() => [
      { text: 'All', value: 'All' },
      { text: 'Full Payment', value: 'Full Payment' },
      { text: 'DP', value: 'DP' },
    ]);

    // Emit to update modal visibility
    const emitUpdateModal = (value) => {
      emit('update:modalFilter', value);
    };

    // Emit selected filter status then close modal
    const applyFilter = () => {
      emit('filter', { status: selectedStatus.value });
      emitUpdateModal(false);
    };

    // Reset filter selection and emit empty filter
    const resetFilter = () => {
      selectedStatus.value = null;
      emit('filter', { status: null });
    };

    return {
      selectedStatus,
      statusOptions,
      emitUpdateModal,
      applyFilter,
      resetFilter,
    };
  }
};
</script>

<style scoped>
/* Custom styles if needed */
</style>
